import React from 'react';
import { useLocation, useNavigate } from 'react-router';

export default function useHistory() {
  const location = useLocation();
  const currentHistory: string[] = React.useMemo(() => location.state?.history, [location.state]);
  const navigate = useNavigate();

  return React.useMemo(() => ({
    hasHistory: !!currentHistory?.length,
    navigate(path: string, replace?: boolean) {
      if (replace) {
        navigate(path, { state: { history: currentHistory ?? [] } });
      } else {
        const currentSearch = location.search;
        const currentPath = location.pathname;
        const newEntry = `${currentPath}${currentSearch}`;
        const newHistory = [newEntry, ...(currentHistory ?? [])];
        navigate(path, { state: { history: newHistory } });
      }
    },
    currentHistoryState: { history: currentHistory ?? [] },
    newHistoryState: { history: [location.pathname, ...(currentHistory ?? [])] },
    goBack() {
      const [previous, ...history] = currentHistory;
      navigate(previous, { state: { history } });
    },
  }), [currentHistory, location.pathname, location.search]);
}
